import React, {useEffect, useState} from 'react';
import LoginModal from "../login/LoginModal";
import FooterDefault from "../footer/common-footer";
import Header from "./Header";
import MobileMenu from "../header/MobileMenu";
import Main1 from "../lahalle/main1";
import Main2 from "../lahalle/main2";
import Libre1 from "../lahalle/libre1";
import Seo from "../common/Seo";
import FormModel from "../form/FormModel";
import Ressources from "../../pages/lahalle/Ressources";
import { motion } from 'framer-motion';
import Main3 from "./main3";
import FAQ from "../../pages/lahalle/FAQ";
import Avis from "./avis";
import Hero from "./hero";
import Webinaires from "./webinaires";

const HomeLahalle = () => {
    const [isPageLoaded, setIsPageLoaded] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    // 👉 OPTION pour activer / désactiver le login
    const enableLogin = false; // mets "false" si tu veux désactiver le LoginModal

    useEffect(() => {
        const loadTimeout = setTimeout(() => {
            setIsPageLoaded(true);
        }, 1000);

        return () => clearTimeout(loadTimeout);
    }, []);



    // --- Vérifie si on doit afficher la page directement ou via Login
    const canAccessPage = !enableLogin || isLoggedIn;

    return (
            <>
                <Seo
                    pageTitle='Hotline La Halle x Talents Handicassp'
                    pageDescription="Hotline La Halle x Talents Handicap"
                    pageUrl={window.location.href}
                    imageUrl="/images/hotline-TH%201.png"
                    favIcon="/favicon-GTH.png"
                    page='lahalle'
                />
                {enableLogin && (
                    // Login modal blocks until password is correct
                    <LoginModal
                        isOpen={!isLoggedIn}
                        onSuccess={() => setIsLoggedIn(true)}
                        clientPassword={"gth-lahalle-2025"}
                        pageToken={"lahalle"}
                    />
                )}
                {canAccessPage  && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ ease: 'easeInOut', duration: 0.5 }}>


                    <span className="header-span"></span>

                    <Header secondLogo={true}/>

                    <MobileMenu
                        secondLogo={true}
                        lienLogo="/images/lahalle.png"
                        lienPage="/lahalle"
                        altLogo='LaHalle'
                        showMenu={true}
                        page="lahalle"
                    />

                    <Hero />
                    <Libre1/>

                    <Main2/>

                    <Main1/>

                    <Main3/>

                    <Ressources/>

                    <FAQ/>

                    <Webinaires />

                    <Avis />

                    <section className="contact-section layout-pb-50 layout-pt-50">
                    {/*todo:boursorama*/}
                    {/*<section className="contact-section contact-section-alternate layout-pb-50 layout-pt-50">*/}
                        <div className="auto-container">
                            <div className="text-center">
                                <h2 className="libre-title raleway">
                                    Nous contacter <span>en cas de besoin !</span>
                                </h2>

                                <div className="text mt-15 nunito">
                                    Pour toute question, une demande d’aide ou une difficulté pour réserver un rendez-vous,
                                    contactez-nous ! Nous vous répondrons dans les meilleurs délais.
                                    Vos messages seront traités par l’équipe Talents Handicap de manière totalement
                                    anonyme.
                                </div>
                            </div>
                            <div className="d-flex justify-content-center w-100">
                                <div className="contact-form default-form">
                                    <FormModel formEntreprise={false} entrepriseName={"lahalle"} type={2} />
                                </div>
                            </div>
                        </div>
                    </section>

                    {isPageLoaded && (
                        <FooterDefault footerStyle="style-six alternate -type-11"/>
                        // <FooterDefault footerStyle=""/> todo:boursorama
                    )}
                    </motion.div>
                )}
            </>
    );
};

export default HomeLahalle;
